import {
  getWeekdayWithId,
  weekdays,
} from "../../../helpers/utils/calendar.util";
import { mod } from "../../../helpers/utils/math.util";
import { SchedulerLesson } from "../../../models/schedule/lesson";
import { SchedulerViewModeBase } from "./SchedulerViewModeBase";

/**
 * Diplays the lesson for a whole week (monday to friday) no matter where the effective lessons start.
 *
 * Prerequisits: The lessons that are given to the view mode have to be prefixed and postfixed with empty lessons.
 * The view mode will not automatically add lessons on monday and tuesday if the lessons of the schedule start on wednesday, this has to be done beforehand.
 */
export class ViewModeWeek extends SchedulerViewModeBase {
  constructor(
    isReadOnly: boolean,
    private startsWithMonday = true,
  ) {
    super(isReadOnly);
  }

  getWeekday(
    startDate: Date,
    day: number,
  ): { id: number; name: string; shortName: string } {
    return this.startsWithMonday
      ? weekdays[mod(day, 5)]
      : getWeekdayWithId(startDate, day);
  }

  toggleActive(
    day: number,
    duration: number,
    lessons: SchedulerLesson[][],
  ): SchedulerLesson[] {
    if (this.isReadOnly) {
      return [];
    }
    const newLessons: SchedulerLesson[] = [];
    const lesson = lessons[day][duration];

    newLessons.push({ ...lessons[day][duration], isActive: !lesson.isActive });

    return newLessons;
  }

  setDay(
    day: number,
    value: boolean,
    lessons: SchedulerLesson[][],
  ): SchedulerLesson[] {
    if (this.isReadOnly) {
      return [];
    }
    const newLessons: SchedulerLesson[] = [];
    for (let j = 0; j < lessons[day].length; j++) {
      const lesson = lessons[day][j];
      newLessons.push({
        ...lesson,
        isActive: !!lesson.canActivate ? value : lesson.isActive,
      });
    }

    return newLessons;
  }

  displayLessons(
    startDate: Date,
    lessons: SchedulerLesson[][],
    page = 0,
  ): SchedulerLesson[][] {
    const pageOffset = page * 5;
    return [...lessons.slice(0 + pageOffset, 5 + pageOffset)];
  }

  hasPage(page: number, lessons: SchedulerLesson[][]): boolean {
    const index = page * 5;
    return !!lessons[index];
  }
}
